import { Typography } from '@material-ui/core';
import React from 'react';
import { mixpanel } from '~/third_party/Mixpanel.jsx';
import Callout from '../ui-kit/Callout/Callout';
import QAAccordion from '../faq/QAAccordion';

const FAQ_SET = [
  {
    question: 'Q: Where is Chowbus available?',
    answer: (
      <Typography paragraph>
        A: U.S.: Austin, Ann Arbor, Atlanta, Boston, Bay Area, Champaign, Chicago, Columbus,
        Washington, D.C., Edison, Houston, Jersey City, Lansing, Los Angeles, Minneapolis, New York
        City, Philadelphia, San Diego, San Francisco, Seattle, St. Louis, West Lafayette Canada:
        Toronto, Vancouver
      </Typography>
    ),
  },
  {
    question: 'Q: What materials do I need to be a Chowbus driver?',
    answer: (
      <Typography paragraph>
        A: To earn money, all you need is a smartphone (iPhone: iOS 12.0 or above or Android:
        version 8.0 or above) and a mode of transportation, such as a car, scooter, or motorcycle
        (in select cities).
      </Typography>
    ),
  },
  {
    question: 'Q: Are there car requirements for driving with Chowbus?',
    answer: (
      <>
        <Typography paragraph>
          A: Nope. You are welcome to use any car to drive, deliver, and earn extra income. You will
          need a valid driver’s license and vehicle insurance.
        </Typography>
        <ul>
          <li>18 years or older</li>
          <li>A smartphone – iPhone or Android </li>
          <li>Any car, scooter, or bicycle (in select cities)</li>
          <li>Driver's license number</li>
          <li>Vehicle insurance</li>
          <li>Final Step: consent to a background check (in select cities)</li>
        </ul>
      </>
    ),
  },
  {
    question: 'Q: Why should I be a Chowbus driver?',
    answer: (
      <Typography paragraph>
        A: You're the boss. As an independent contractor, you have the flexibility to deliver orders
        whenever you want. You can make it full-time, part-time, or deliver as your schedule allows.
      </Typography>
    ),
  },
  {
    question: 'Q: Do I need any experience to be a Chowbus driver?',
    answer: (
      <Typography paragraph>
        A: Nope! You do not need any prior work experience. However, if you do have previous
        experience in working with rideshare, food delivery, or courier service businesses, then
        delivering with Chowbus is a great way to use your existing skills to help us in our mission
        to connect people to authentic Asian cuisine.
      </Typography>
    ),
  },
];

const DriverFaq = () => {
  return (
    <>
      <Callout title='FAQs' titleBorderColor='#15d0c5' />
      {FAQ_SET.map(({ question, answer }, index) => {
        return (
          <QAAccordion
            question={question}
            answer={answer}
            id={index + 1}
            key={index}
            handleChange={(event, expanded) => {
              if (expanded) {
                mixpanel.track({
                  name: `restaurants page: user expands FAQ question`,
                  properties: {
                    question,
                  },
                });
              }
            }}
          />
        );
      })}
    </>
  );
};

export default DriverFaq;
